import ApiService from './ApiService';

const PurchaseJobsService = {

  getList({ filters, orderPath, ...params }) {
    const updatedParams = { ...params };

    if (filters && Object.keys(filters).length) {
      for (let key in filters) {
        if (key === 'Dates') {
          updatedParams.fromTs = filters[key][0];
          updatedParams.toTs = filters[key][1];
        } else {
          updatedParams[key] = filters[key].join(',');
        }
      }
    }

    if (orderPath) {
      updatedParams.order = orderPath.replace('end', '');
    }

    return ApiService.get('/job', { ...updatedParams, jobName: 'Purchase' });
    // return ApiService.get('/job/Purchase/0/50');
  },

  cancel(jobIds) {
    return ApiService.post('/jobs/cancel', { jobIds });
  },
};

export default PurchaseJobsService
